export const requestStart = label => {
  return {
    type: 'REQUEST_START',
    label: label,
  }
}

export const requestEnd = label => {
  return {
    type: 'REQUEST_END',
    label: label,
  }
}
export const toggleErrorModal = (toggle, customText = null) => {
  return {
    type: 'TOGGLE_ERROR_MODAL',
    toggle: toggle,
    customText: customText,
  }
}
export const toggleLimitOfSaleModal = (toggle, customText = null) => {
  return {
    type: 'TOGGLE_LIMIT_OF_SALE_MODAL',
    toggle: toggle,
    customText: customText,
  }
}
